export default __webpack_public_path__ + "static/media/hsbc.7b5256fc.png";